import { render } from "./IconPlusTiny.vue?vue&type=template&id=899bce2e"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconPlusTiny.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "899bce2e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('899bce2e', __exports__)) {
    api.reload('899bce2e', __exports__)
  }
  
  module.hot.accept("./IconPlusTiny.vue?vue&type=template&id=899bce2e", () => {
    api.rerender('899bce2e', render)
  })

}


export default __exports__